import { ActionButton } from '../../../components/common/ActionButton';
import { ContentsHeader } from '../../../components/common/ContentsHeader';
import { ClientAdminUserType } from '../../../types/resources/ClientAdminUserType';
import { convertDateTime } from '../../../utils/dateTime';
import { getClientAdminUserEditLink } from '../../../utils/getLinks';
import styles from './styles.module.scss';

type StandardClientAdminUserProps = {
  clientAdminUser: ClientAdminUserType;
};

export const StandardClientAdminUser = ({ clientAdminUser }: StandardClientAdminUserProps) => {
  return (
    <div className={styles.root}>
      <ContentsHeader
        title='利用企業管理者詳細'
        actions={
          <ActionButton
            href={getClientAdminUserEditLink(String(clientAdminUser?.id) || '')}
            type='dark'
            content={`編集する`}
            data-testid='edit-button'
          />
        }
      />
      <div className={styles.container}>
        <div className={styles.mainContainer}>
          <div className={styles.form}>
            <div className={styles.formTitle}>利用企業名</div>
            <div data-testid='company-name'>{clientAdminUser?.client?.name}</div>
          </div>
          <div className={styles.form}>
            <div className={styles.formTitle}>氏名</div>
            <div data-testid='full-name'>{clientAdminUser?.full_name}</div>
          </div>
          <div className={styles.form}>
            <div className={styles.formTitle}>個人用メールアドレス</div>
            <div data-testid='personal-email'>{clientAdminUser?.email}</div>
          </div>
          <div className={styles.form}>
            <div className={styles.formTitle}>作成日時</div>
            <div data-testid='registration-date'>
              {convertDateTime(clientAdminUser?.created_at)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
